import { axios } from '../util'

const API_ENDPOINT = '/v0/user/login/validation'

export const accountRevalidate = token => axios.post(API_ENDPOINT, { token })
